module.exports = __webpack_public_path__ + "img/txt_keyvisual_tablet.17714018.svg";